(() => {
  if (customElements.get('text-fade')) {
    return;
  }

  class TextFade extends HTMLElement {
    constructor() {
      super();

      this.updateAnimation = this.updateAnimation.bind(this);
    }

    connectedCallback() {
      this.initAnimation();

      const handleIntersection = (entries) => {
        if (entries[0].isIntersecting) {
          this.attachEvents();
        } else {
          this.clearEvents();
        }
      };

      new IntersectionObserver(handleIntersection.bind(this)).observe(this);
    }

    attachEvents() {
      window.addEventListener('scroll', this.updateAnimation);
    }

    clearEvents() {
      window.removeEventListener('scroll', this.updateAnimation);
    }

    updateAnimation() {
      this.updateLetters();
    }

    initAnimation() {
      this.lettersContainer = this.querySelector('[data-latters]');
      this.updateLetters = this.updateLetters.bind(this);
      this.letters = this.lettersContainer.querySelectorAll('span');
      this.offset = parseFloat(this.dataset.offset, 2) || 0.7;
    }

    updateLetters() {
      let isFinished = false;

      this.letters.forEach((letter) => {
        const { top, left } = letter.getBoundingClientRect();
        const viewPortStartPoint = window.innerHeight * this.offset;
        const opacityPercentPattern = 0.01;
        const leftPositionPercentPattern = 0.001;

        const progressOpacity =
          1 -
          ((top - viewPortStartPoint) * opacityPercentPattern +
            left * leftPositionPercentPattern);

        letter.style.opacity =
          progressOpacity < 0.4
            ? 0.4
            : progressOpacity > 1
            ? 1
            : progressOpacity.toFixed(3);

        isFinished = progressOpacity < 1 ? false : true;
      });

      this.toggleFinishedClass(isFinished);
    }

    toggleFinishedClass(isFinished) {
      this.classList.toggle('is-finished', isFinished);
    }
  }

  customElements.define('text-fade', TextFade);
})();
